<template>
  <div class="reddit-index">
    <div class="rediit-head">
      <div class="head-item" v-for="(item, i) in headArr" :key="i">
        <img :src="item.img" alt="" width="35" height="35" />
        <div class="text-box">
          <div v-if="!item.bold" class="item-text">
            {{ item.memo1 }}
          </div>
          <div v-else class="item-text">
            <span>{{ item.memo1 }}</span>
            {{ item.measurement }}
          </div>
          <div class="item-text">
            {{ item.memo2 }}
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <div class="reddit-content">
      <div>
        <div class="index-title">
          <div>Twitter账号</div>
          <span @click="goPath('/twitter/account')">更多>></span>
        </div>
        <el-table
          :data="accountList"
          header-row-class-name="tableheader"
          style="width: 100%; margin-top: 10px"
          height="280px"
          :row-style="{ height: 0 + 'px' }"
          :cell-style="{ padding: '5px 0' }"
        >
          <el-table-column
            prop="name"
            label="昵称"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              <el-tag
                size="mini"
                :type="
                  items.hasOwnProperty(scope.row.status) === true
                    ? items[scope.row.status].type
                    : 'danger'
                "
                effect="dark"
              >
                {{
                  items.hasOwnProperty(scope.row.status) === true
                    ? items[scope.row.status].label
                    : '获取失败'
                }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="last_login_time"
            label="最后登录时间"
          ></el-table-column>
        </el-table>
      </div>
      <div>
        <div class="index-title">
          <div>FaceBook账号</div>
          <span @click="goPath('/facebook/account')">更多>></span>
        </div>
        <el-table
          :data="communityList"
          header-row-class-name="tableheader"
          style="width: 100%; margin-top: 10px"
          height="280px"
          :row-style="{ height: 0 + 'px' }"
          :cell-style="{ padding: '5px 0' }"
        >
          <el-table-column
            prop="name"
            label="昵称"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              <el-tag
                size="mini"
                :type="
                  items.hasOwnProperty(scope.row.status) === true
                    ? items[scope.row.status].type
                    : 'danger'
                "
                effect="dark"
              >
                {{
                  items.hasOwnProperty(scope.row.status) === true
                    ? items[scope.row.status].label
                    : '获取失败'
                }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="last_login_time"
            label="最后登录时间"
          ></el-table-column>
        </el-table>
      </div>
      <div>
        <div class="index-title">
          <div>YouTube账号</div>
          <span @click="goPath('/youTube/account')">更多>></span>
        </div>
        <el-table
          :data="ytbaccountList"
          header-row-class-name="tableheader"
          style="width: 100%; margin-top: 10px"
          height="280px"
          :row-style="{ height: 0 + 'px' }"
          :cell-style="{ padding: '5px 0' }"
        >
          <el-table-column
            prop="user_name"
            label="用户名"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              <el-tag
                size="mini"
                :type="
                  items.hasOwnProperty(scope.row.status) === true
                    ? items[scope.row.status].type
                    : 'danger'
                "
                effect="dark"
              >
                {{
                  items.hasOwnProperty(scope.row.status) === true
                    ? items[scope.row.status].label
                    : '获取失败'
                }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="last_login_time"
            label="最后登录时间"
          ></el-table-column>
        </el-table>
      </div>
    </div>
    <div class="reddit-foot">
      <div class="foot-left">
        <div class="index-title">近七天发布统计</div>
        <div id="echarts"></div>
      </div>
      <div class="foot-right">
        <div class="index-title">
          <div>积分记录</div>
          <span @click="goPath('/service/pointsMenu')">更多>></span>
        </div>
        <el-table
          :data="pointsList"
          header-row-class-name="tableheader"
          style="width: 100%; margin-top: 10px"
          :height="windowsHeight - 625"
          :row-style="{ height: 0 + 'px' }"
          :cell-style="{ padding: '5px 0' }"
        >
          <el-table-column prop="id" label="ID" width="50px"></el-table-column>
          <el-table-column
            prop="points_value"
            label="积分变动"
            width="150px"
          ></el-table-column>
          <el-table-column prop="details" label="详述"></el-table-column>
          <el-table-column
            prop="create_time"
            label="变动时间"
          ></el-table-column>
        </el-table>
      </div>
      <div class="foot-2">
        <div class="index-title">任务类别统计</div>
        <div id="echarts-2"></div>
      </div>
      <div class="foot-3">
        <div class="index-title">任务状态统计</div>
        <div id="echarts-3"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import {
  getTwitterList,
  getFacebookList,
  getYoutubeList,
  getUserPoints,
  getSummary,
  getMyMonitorTask,
  categoryApi,
  taskStatusApi
} from '@/api/index'

export default {
  data() {
    return {
      noPic: 'this.src="' + require('@/assets/imgs/p.jpg') + '"',
      headArr: [
        {
          img: require('../../assets/imgs/t1.png'),
          memo1: '开通日期：2020-03-01',
          memo2: '结束日期：2020-03-01',
          bold: false
        },
        {
          img: require('../../assets/imgs/t2.png'),
          memo1: 0,
          memo2: '购买数量/累计使用数量',
          bold: true,
          measurement: ''
        },
        {
          img: require('../../assets/imgs/t3.png'),
          memo1: 0,
          memo2: 'twitter发帖',
          bold: true,
          measurement: ''
        },
        {
          img: require('../../assets/imgs/t4.png'),
          memo1: 0,
          memo2: '购买数量/累计使用数量',
          bold: true,
          measurement: ''
        },
        {
          img: require('../../assets/imgs/t5.png'),
          memo1: '0',
          memo2: 'facebook发帖',
          bold: true,
          measurement: ''
        },
        {
          img: require('../../assets/imgs/t6.png'),
          memo1: '0',
          memo2: '购买数量/累计使用数量',
          bold: true,
          measurement: ''
        },
        {
          img: require('../../assets/imgs/t7.png'),
          memo1: '0',
          memo2: 'youtube发布',
          bold: true,
          measurement: ''
        }
      ],
      communityList: [],
      communityArr: [],
      accountList: [],
      userList: [],
      ytbaccountList: [],
      pointsList: [],
      pageIndex: 1,
      pageSize: 10,
      items: {
        1: {
          type: 'success',
          label: '正常'
        },
        0: {
          type: 'warning',
          label: '异常'
        },
        '-1': {
          type: 'danger',
          label: '失效',
          tip: '该账号因为异常行为已被暂停使用'
        }
      }
    }
  },
  computed: {
    windowsHeight() {
      return this.$store.state.windowData.height
    }
  },
  mounted() {
    // 获取头部6个数据
    this.getHead()
    // 获取折线图的数据
    this.getEcharts()

    // 账号
    this.getTwitterData()
    this.getFaceData()
    this.getYtbData()
    // 积分
    this.getPointData()
    //
    this.getEchartsData()
  },
  methods: {
    goPath(path) {
      this.$router.push(path)
    },

    // twitter账号
    getTwitterData() {
      const obj = {
        pageIndex: 1,
        pageSize: 7
      }
      getTwitterList(obj).then(res => {
        this.accountList = res.items
      })
    },
    // facebook账号
    getFaceData() {
      const obj = {
        pageIndex: 1,
        pageSize: 7
      }
      getFacebookList(obj).then(res => {
        this.communityList = res.items
      })
    },
    // youtube 账号
    getYtbData() {
      const obj = {
        pageIndex: 1,
        pageSize: 7
      }
      getYoutubeList(obj).then(res => {
        // console.log(res)
        this.ytbaccountList = res.items
      })
    },
    // 积分记录
    getPointData() {
      getUserPoints(this.pageIndex, this.pageSize).then(res => {
        // console.log(res)
        this.pointsList = res.items
      })
    },
    getHead() {
      getSummary().then(res => {
        // console.log(res)
        const {
          twitter_account_count: twitterAccountCount,
          twitter_post_task_count: twitterPostTaskCount,
          facebook_account_count: facebookAccountCount,
          facebook_post_task_count: facebookPostTaskCount,
          youtube_account_count: youTubeAccountCount,
          youtube_post_task_count: youTubePostTaskCount
        } = res
        this.headArr[0].memo1 =
          '开通日期：' + this.$store.state.user.userInfo.create_time
        this.headArr[0].memo2 =
          '结束日期：' + this.$store.state.user.userInfo.end_time
        this.headArr[1].memo1 =
          this.$store.state.user.userInfo.buy_twitter_account +
          '/' +
          twitterAccountCount
        this.headArr[2].memo1 = twitterPostTaskCount
        this.headArr[3].memo1 =
          this.$store.state.user.userInfo.buy_facebook_account +
          '/' +
          facebookAccountCount
        this.headArr[4].memo1 = facebookPostTaskCount
        this.headArr[5].memo1 =
          this.$store.state.user.userInfo.buy_youtube_account +
          '/' +
          youTubeAccountCount
        this.headArr[6].memo1 = youTubePostTaskCount
      })
    },
    getEcharts() {
      getMyMonitorTask().then(res => {
        console.log(res)
        const {
          x_axis: xAxis,
          y_axis_facebook: yAxisFacebook,
          y_axis_twitter: yAxisTwitter,
          y_axis_youtube: yAxisYouTube
        } = res
        this.getEchartsLine(
          'echarts',
          xAxis,
          yAxisFacebook,
          yAxisTwitter,
          yAxisYouTube
        )
      })
    },
    getEchartsLine(dom, dataX, yAxisFacebook, yAxisTwitter, yAxisYouTube) {
      const chart = echarts.init(document.getElementById(dom))
      const option = {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['facebook', 'twitter', 'youtube']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: dataX
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: 'facebook',
            type: 'line',
            data: yAxisFacebook,
            smooth: true
          },
          {
            name: 'twitter',
            type: 'line',
            data: yAxisTwitter,
            smooth: true
          },
          {
            name: 'youtube',
            type: 'line',
            data: yAxisYouTube,
            smooth: true
          }
        ]
      }
      window.onresize = function() {
        chart.resize()
      }
      chart.setOption(option)
    },
    getEchartsData() {
      categoryApi().then(data => {
        this.categoryFn('echarts-2', data)
      })
      taskStatusApi().then(data => {
        this.categoryFn('echarts-3', data)
      })
    },
    // 任务类别
    categoryFn(dom, data) {
      let chart = echarts.init(document.getElementById(dom))
      const option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: [
          {
            name: '任务类别统计',
            type: 'pie',
            radius: '50%',
            data: data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      window.onresize = function() {
        chart.resize()
      }
      // window.addEventListener('resize', chart.resize())
      chart.setOption(option)
    }
  }
}
</script>

<style lang="scss" scoped>
.reddit-index {
  width: 100%;
  height: calc(100vh - 50px);
  padding: 10px 20px;
  background: rgb(240, 242, 245);

  .rediit-head {
    width: 100%;
    height: 130px;
    background: white;
    border-radius: 5px;
    display: flex;
    box-shadow: 0 1px 3px 0 #d8d9d9;
    .head-item {
      width: calc(100% / 7 - 1px);
      height: 131px;
      border-right: 1px solid #f2f4f8;
      display: flex;
      flex-direction: column;
      justify-content: center;
      overflow: hidden;
      &:nth-last-child(1) {
        border-right: none;
      }
      img {
        height: auto;
        object-fit: cover;
        align-self: center;
      }
      .text-box {
        align-self: center;
        margin-top: 10px;
        text-align: center;
        .item-text {
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          line-height: 24px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          span {
            font-size: 22px;
          }
        }
      }
    }
  }
  .reddit-content {
    height: 337px;
    margin: 10px 0;
    display: flex;
    justify-content: space-between;
    > div {
      width: 33%;
      height: 100%;
      background: #ffffff;
      border-radius: 5px;
      padding: 5px;
      overflow: hidden;
      box-shadow: 0 1px 3px 0 #d8d9d9;
    }
  }
  .reddit-foot {
    margin: 10px 0;
    display: flex;
    justify-content: space-between;

    > div {
      background: white;
      border-radius: 5px;
      height: 100%;
      padding: 5px;
      box-shadow: 0 1px 3px 0 #d8d9d9;
    }
    .foot-left {
      width: 25%;
    }
    .foot-right {
      width: 25%;
    }
    .foot-2 {
      width: 24%;
      #echarts-2 {
        width: 100%;
        height: calc(100vh - 615px);
        overflow: hidden;
      }
    }
    .foot-3 {
      width: 24%;
      #echarts-3 {
        width: 100%;
        height: calc(100vh - 615px);
        overflow: hidden;
      }
    }
    #echarts {
      width: 100%;
      height: calc(100vh - 615px);
    }
  }
  .index-title {
    display: flex;
    justify-content: space-between;
    text-indent: 10px;
    font-size: 14px;
    font-weight: 400;
    color: #4a4a4a;
    line-height: 24px;
    border-bottom: 1px solid #f4f4f4;
    padding: 5px 0;
    font-weight: 600;
    span {
      color: #7c7b7b;
      cursor: pointer;
      &:hover {
        color: rgb(11, 106, 214);
      }
    }
  }
  // ::v-deep .el-table__header .el-table__cell {
  //   background: rgb(243, 247, 249);
  // }
  ::v-deep .tableheader th {
    background: rgb(243, 247, 249);
    padding: 8px 0;
  }
  .table-cell-img {
    width: 28px;
    height: 28px;
    object-fit: cover;
    vertical-align: middle;
  }
}
</style>
